import "./login.css";
import React from "react";

export const FooterLogin = () => {
  return (
    <footer>Desarrollado por “The Reactive Girls” - Laboratoria SCL016</footer>
  );
};